import { render, staticRenderFns } from "./FeeTransparencyDisclaimer.vue?vue&type=template&id=27afcda4&scoped=true"
import script from "./FeeTransparencyDisclaimer.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeeTransparencyDisclaimer.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FeeTransparencyDisclaimer.vue?vue&type=style&index=0&id=27afcda4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27afcda4",
  null
  
)

export default component.exports